module.exports = __webpack_public_path__ + "static/media/licenca-megga.18b457c7.pdf";